import { useState } from "react";
import Window from "../../components/Window";
import TouchableOpacity from "../../widgets/TouchableOpacity";
import styles from "./styles.jsx";
import { getSize, getIP } from "../../utils";
import { isSignedIn, handleAuth, handleSignOut } from "../../api/gapi";
import ToggleButton from "react-toggle-button";
import { Select } from "antd";

const GeneralInfo = ({ fileSystem, userInfo, localMode }) => {
  const [gSignedIn, setGSignedIn] = useState(isSignedIn());

  return (
    <div style={styles.page}>
      <div style={styles.section}>
        <div style={styles.title}>File System</div>
        <div style={styles.row}>
          <p>File System Size</p> <p>{getSize(fileSystem.getRawSize())}</p>
        </div>
        <div style={styles.row}>
          <p>Data Size</p> <p>{getSize(fileSystem.getDirectorySize("root"))}</p>
        </div>
        <div style={styles.row}>
          <p>Trash Data Size</p>
          <p>{getSize(fileSystem.getDirectorySize("bin"))}</p>
        </div>
        <div style={styles.row}>
          <p>Directories</p> <p>{fileSystem.getNumDirs()}</p>
        </div>
        <div style={styles.row}>
          <p>Files</p> <p>{fileSystem.getNumFiles()}</p>
        </div>
        <div style={styles.row}>
          <p>Apps</p> <p>{fileSystem.getNumApps()}</p>
        </div>
      </div>
      <div style={styles.section}>
        <div style={styles.title}>User State</div>
        <div style={styles.row}>
          <p>Local Mode</p> <p>{String(localMode)}</p>
        </div>
        <div style={styles.row}>
          <p>Google Drive Connected</p>{" "}
          <ToggleButton
            thumbStyle={{
              boxShadow: "0px 0px 2px white",
            }}
            colors={{
              active: {
                base: "#32CD32",
                hover: "#228B22",
              },
              inactive: {
                base: "rgb(65,66,68)",
                hover: "rgb(95,96,98)",
              },
            }}
            inactiveLabel={""}
            activeLabel={""}
            value={gSignedIn}
            onToggle={(signedIn) => {
              if (signedIn) {
                handleSignOut();
                setGSignedIn(!gSignedIn);
              } else {
                handleAuth();
                setGSignedIn(!gSignedIn);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

const NetworkInfo = () => {
  const [ip, setIp] = useState("N/A");
  useState(async () => {
    const res = await getIP();
    setIp(res);
  }, []);
  return (
    <div style={styles.page}>
      <div style={styles.section}>
        <div style={styles.title}>Network</div>
        <div style={styles.row}>
          <p>Est. Link Speed</p>
          <p>
            {navigator.connection
              ? navigator.connection.downlink + " Mbs"
              : "N/A"}
          </p>
        </div>
        <div style={styles.row}>
          <p>Client IP</p>
          <p>{ip}</p>
        </div>
      </div>
    </div>
  );
};

const DisplayInfo = ({ systemData, updateSystemData, backgrounds }) => {
  const backgroundThumbs = [];
  const setBackgroundIndex = (index) => {
    updateSystemData({ backgroundIndex: index });
  };
  const setIconSize = (size) => {
    updateSystemData({ iconSize: size });
  };
  const setRollingInterval = (inv) => {
    updateSystemData({ rollingInterval: inv });
  };
  backgrounds.map((back, index) =>
    backgroundThumbs.push(
      <TouchableOpacity
        style={{
          ...styles.picture,
          backgroundSize: "cover",
          backgroundImage: `url(${back})`,
          borderColor: systemData.backgroundIndex === index ? "white" : "black",
        }}
        key={index}
        onClick={() => setBackgroundIndex(index)}
      />
    )
  );
  return (
    <div style={styles.page}>
      <div style={styles.section}>
        <div style={styles.title}>Background</div>
        <div style={styles.row}>{backgroundThumbs}</div>
        <div style={styles.row}>
          <p>Rolling</p>
          <ToggleButton
            thumbStyle={{
              boxShadow: "0px 0px 2px white",
            }}
            colors={{
              active: {
                base: "#32CD32",
                hover: "#228B22",
              },
              inactive: {
                base: "rgb(65,66,68)",
                hover: "rgb(95,96,98)",
              },
            }}
            inactiveLabel={""}
            activeLabel={""}
            value={systemData.rollingBackground}
            onToggle={(rolling) => {
              updateSystemData({
                rollingBackground: !rolling,
              });
            }}
          />
        </div>
        <div style={styles.row}>
          <p>Interval</p>
          <Select
            disabled={!systemData.rollingBackground}
            defaultValue={
              systemData.rollingInterval ? systemData.rollingInterval : 30
            }
            style={{ width: 100 }}
            size="small"
            onChange={setRollingInterval}
          >
            <Select.Option value={15}>15s</Select.Option>
            <Select.Option value={30}>30s</Select.Option>
            <Select.Option value={60}>60s</Select.Option>
            <Select.Option value={120}>120s</Select.Option>
          </Select>
        </div>
      </div>
      <div style={styles.section}>
        <div style={styles.title}>Icons</div>
        <div style={styles.row}>
          <p>Scaling</p>
          <Select
            defaultValue={systemData.iconSize ? systemData.iconSize : 1}
            style={{ width: 100 }}
            size="small"
            onChange={setIconSize}
          >
            <Select.Option value={0.5}>50%</Select.Option>
            <Select.Option value={0.75}>75%</Select.Option>
            <Select.Option value={1}>100%</Select.Option>
            <Select.Option value={1.5}>150%</Select.Option>
          </Select>
        </div>
      </div>
    </div>
  );
};

const menuMap = {
  General: (props) => <GeneralInfo {...props} />,
  Network: (props) => <NetworkInfo {...props} />,
  Display: (props) => <DisplayInfo {...props} />,
};

const SettingApp = ({
  onCancel,
  fileSystem,
  userInfo,
  localMode,
  backgrounds,
  systemData,
  updateSystemData,
}) => {
  const [currentPage, setCurrentPage] = useState("General");
  const menuEntries = [];
  Object.keys(menuMap).map((key) =>
    menuEntries.push(
      <TouchableOpacity
        style={styles.sideBarEntry}
        onClick={() => setCurrentPage(key)}
        key={key}
      >
        {key}
      </TouchableOpacity>
    )
  );
  const Page = menuMap[currentPage];
  return (
    <Window
      top={0}
      left={0}
      id={"setting"}
      name={"Setting"}
      width={500}
      minWidth={500}
      height={500}
      minHeight={300}
      onCancel={onCancel}
    >
      <div style={styles.frame}>
        <div style={styles.sideBar}>{menuEntries}</div>
        {
          <Page
            fileSystem={fileSystem}
            userInfo={userInfo}
            localMode={localMode}
            systemData={systemData}
            updateSystemData={updateSystemData}
            backgrounds={backgrounds}
          />
        }
      </div>
    </Window>
  );
};

export default SettingApp;
